import React from "react";

export function BQueenIcon({ color = "#5F5955" }: { color?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 131 155"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.3332 3.2529C62.0093 3.2529 58.8215 4.43077 56.4711 6.5274C54.1207 8.62403 52.8003 11.4677 52.8003 14.4327C52.7998 15.9012 53.1235 17.3554 53.7531 18.7122C54.3827 20.0691 55.3058 21.302 56.4696 22.3405C57.6335 23.3791 59.0153 24.2029 60.5361 24.765C62.057 25.3271 63.687 25.6164 65.3332 25.6164C66.9794 25.6164 68.6095 25.3271 70.1303 24.765C71.6512 24.2029 73.033 23.3791 74.1968 22.3405C75.3607 21.302 76.2838 20.0691 76.9134 18.7122C77.5429 17.3554 77.8667 15.9012 77.8661 14.4327C77.8661 11.4677 76.5457 8.62403 74.1953 6.5274C71.845 4.43077 68.6572 3.2529 65.3332 3.2529Z"
        fill={color}
        stroke={color}
        stroke-width="4.53506"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.3332 25.6164C40.7398 25.6164 29.0687 47.8551 29.0687 64.7647H101.874C101.874 47.8551 89.9304 25.6164 65.3332 25.6164Z"
        fill={color}
        stroke={color}
        stroke-width="4.53543"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.4882 41.5433C58.0387 41.5433 56.6139 51.559 49.8523 52.3527C42.9735 53.1578 37.0737 43.6145 30.0098 45.7877C24.3594 47.5263 27.0693 55.6145 23.1877 57.7877C17.8888 60.7546 11.1499 50.8636 3.19401 56.6614C29.0384 90.0309 33.7515 103.441 33.366 127.788H97.6104C97.2211 103.437 101.934 90.0309 127.782 56.6576C119.823 50.8636 113.084 60.7546 107.789 57.7915C103.907 55.6145 106.613 47.5263 100.963 45.7877C93.9027 43.6145 88.0028 53.1578 81.1203 52.349C74.3587 51.5553 72.9339 41.5395 65.4844 41.5395L65.4882 41.5433Z"
        fill={color}
        stroke={color}
        stroke-width="4.53506"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.4882 121.79C65.4882 121.79 30.9811 121.972 21.3017 127.913C14.7745 131.919 13.2324 141.708 14.1206 151.811H116.856C117.744 141.712 116.206 131.916 109.675 127.909C99.9991 121.972 65.492 121.786 65.492 121.786L65.4882 121.79Z"
        fill={color}
        stroke={color}
        stroke-width="4.53543"
        stroke-linejoin="round"
      />
    </svg>
  );
}
